import { Component, inject } from '@angular/core';
import { ToastComponent } from './toast.component';
import { ToastService } from './toast.service';

@Component({
  selector: 'lib-toast-container',
  imports: [ToastComponent],
  styleUrls: ['./toast-container.component.css'],
  templateUrl: './toast-container.component.html',
  host: {
    'aria-live': 'polite',
    'aria-atomic': 'false',
  },
})
export class ToastContainerComponent {
  protected readonly toastService = inject(ToastService);
}
